import { Form, Formik } from "formik";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getUserLogin } from "../../modules/userLogin/getUserLogin";
import { UserLoginResponseSelector } from "../../modules/userLogin/selectors";
import { RootState } from "../../utils/types";
import * as Yup from "yup";
import {
  LoginSocialFacebook,
  LoginSocialApple,
  IResolveParams,
} from "reactjs-social-login";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import { getUserLoginSocial } from "../../modules/userLogin/getUserLoginSocial";
import { setSocialDetails } from "../../modules/userLogin/setSocialDetails";
import { DefaultLayout } from "../../layout/DefaultLayout";
import { getCartItems } from "../../modules/cartItems/getCartItems";
import { ResetUserLogin, ResetVerification } from "../../modules/userLogin/slice";
import ResendVerficationModel from "./ResendVerificationModel";
import { notify } from "../../modules/notification/notify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addToCart } from "../../modules/buyer/product/addToCart";
import { resetSave } from "../../modules/buyer/product/resetSave";
import { constant } from "../../utils/constant";

export const Login = (props: any) => {
  interface formValues {
    emailId: string;
    password: string;
    error: string;
    type:number;
    fCMToken: null;
  }
  const navigate = useNavigate();
  let userResponse = useSelector<RootState, RootState["login"]>(
    UserLoginResponseSelector
  );

  const onLoginStart = useCallback(() => {
    // alert("login start");
  }, []);

  // useEffect(() => {
  //   if (userResponse.provider == "facebook" && userResponse.profile !== null)
  //     dispatch<any>(
  //       getUserLoginSocial({
  //         accesstoken: userResponse.profile.accessToken,
  //         socialType: 2,
  //         roleId: 2,
  //         roleType: "Customer",
  //       })
  //     );
  //   if (userResponse.provider == "google" && userResponse.profile !== null)
  //     dispatch<any>(
  //       getUserLoginSocial({
  //         accesstoken: userResponse.profile.tokenId,
  //         socialType: 1,
  //         roleId: 2,
  //         roleType: "Customer",
  //       })
  //     );
  // }, [userResponse.provider, userResponse.profile]);
  useEffect(() => {
    const initClient = () => {
      gapi?.client?.init({
        clientId:
          constant.GOOGLE_CLIENT_ID,
        scope: "",
      });
    };
    gapi.load("client:auth2", initClient);
  });


  const onSuccess = (res: any) => {
    dispatch<any>(
      setSocialDetails({
        provider: "google",
        profile: res,
        type: "login",
      })
    ).then(()=>res && dispatch<any>(
      getUserLoginSocial({
        accesstoken: res.tokenId,
        socialType: 1,
          roleId: 2,
          roleType: "Customer",
      })
    ));
  };
  const onFailure = (err: any) => {
  };
  // const onLogout = useCallback(() => {}, []);
 
  const isFirstRender = React.useRef(true);

  const dispatch = useDispatch();

  const [user, setUserValue] = useState<formValues>({
    emailId: "",
    password: "",
    error: "",
    type:2,
    fCMToken:null,
  });
  const [visible,setVisible]=useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleCheckboxClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setRememberMe(checked);
  };
  const setUserData = (e: any) => {
    setUserValue({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const ProfileSchema = Yup.object().shape({
    emailId: Yup.string().email("Please enter a valid email.").min(2, "Too Short!").required("*Required!"),
    password: Yup.string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("*Required!"),
  });

  useEffect(() => {
    if (!isFirstRender.current) {
      localStorage.removeItem("activationToken")
      if (userResponse.login != null) {
        if (userResponse.login.success === "Y") {
          const accessToken = localStorage.getItem("authorization");
          //   localStorage.removeItem("error");

          if (
            userResponse.login.data.roleCode === "Customer" &&
            accessToken !== null
          ) {
            setUserValue({ ...user, error: "" });
            
            dispatch<any>(getCartItems());
            let cart=JSON.parse(localStorage.getItem("cart") || "[]");
            if(cart.length>0 && localStorage.getItem("authorization") !== null &&
            localStorage.getItem("role") === "Customer") 
            {
              let newCart:any=[];
              cart.forEach((element:any) => {
                newCart.push({  productId: element.productId,
                  quantity: element.quantity,
                  VariantId:element.variantId,})
              });
             dispatch<any>( addToCart({
              isCart: false,
              
              Cart:newCart})).then(()=>localStorage.setItem("cart", JSON.stringify([]))).then(()=>dispatch<any>(resetSave()));
           
            }

            navigate("/buyer/activity/recentlyViewed", { replace: true });

          } else
            setUserValue({ ...user, error: "Invalid Customer Credentials" });
        }
        if(
          userResponse.login?.success==="N" && userResponse.login?.accountActivationToken
        )
        {
          navigate("/activation", {
            state: userResponse.login?.accountActivationToken,
          });
        }
        if(userResponse.login?.success==="N" && userResponse.login?.isVerified==false)
        {
          setVisible(true);
        }
      }
    }
    else{

      dispatch<any>(ResetUserLogin());
      isFirstRender.current = false;

    }
  
  }, [userResponse?.login, userResponse?.error]);

  useEffect(() => {
    let data = localStorage.getItem("userData");
    if(localStorage.getItem("role")==="Customer" &&  localStorage.getItem("authorization") )
    {
      navigate("/buyer/activity/recentlyViewed", { replace: true });
    }
    if (data) {
      setUserValue({
        ...user,
        emailId: JSON.parse(data).email,
        password: JSON.parse(data).password,
      });
      setRememberMe(true);
    }
  }, []);
  useEffect(() => {
    if (userResponse.resendVerification != null) {
      if (userResponse.resendVerification.success == "Y") {
        notify(userResponse.resendVerification.message, "success");
      } else if (userResponse.resendVerification.success == "N") {
        notify(userResponse.resendVerification.message, "error");
      }
     
  
    }
    if (userResponse.resendVerificationError != null) {
      notify(userResponse?.resendVerificationError, "error");
   
    }
    dispatch<any>(ResetVerification());

  }, [userResponse?.resendVerification, userResponse?.resendVerificationError]);
  const REDIRECT_URI = "https://efindit.net/";

  return (
    <DefaultLayout>
      <ToastContainer/>
  {visible &&  <ResendVerficationModel setVisible={setVisible} email={user?.emailId} />}
      {" "}
      <>
        {" "}
        <header className="header">
          <div className="logo-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="logo">
                    <Link to={"/home"}>
                      <i className="logo-img"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="login-section min-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="login-container">
                  <Formik
                    initialValues={user}
                    validationSchema={ProfileSchema}
                    enableReinitialize={true}
                    onSubmit={(values) => {
                      let userData = {};
                      if (rememberMe) {
                        userData = {
                          email: user.emailId,
                          password: user.password,
                        };
                        localStorage.setItem(
                          "userData",
                          JSON.stringify(userData)
                        );
                      } else localStorage.removeItem("userData");
                      dispatch<any>(getUserLogin(user));
                    }}
                  >
                    {({ errors, touched }) => (
                      <>
                        <Form>
                          <h2 className="h2-head text-center">
                            Buyer Login{" "}
                          </h2>

                          <div className="signin-text text-center">
                            Sign in to efindit or{" "}
                            <Link to={"/register"}>create an account</Link>
                          </div>

                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control login-input"
                              placeholder="Email"
                              value={user.emailId}
                              name="emailId"
                              onChange={setUserData}
                            />
                            {errors.emailId && touched.emailId ? (
                              <div className="invalid-feedback d-block">
                                {errors.emailId}
                              </div>
                            ) : null}
                          </div>

                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control login-input"
                              placeholder="Password"
                              value={user.password}
                              name="password"
                              onChange={setUserData}
                            />
                            {errors.password && touched.password ? (
                              <div className="invalid-feedback d-block">
                                {errors.password}
                              </div>
                            ) : null}
                          </div>
                          {userResponse.error ? (
                            <div className="invalid-feedback d-block">
                              {userResponse.error}
                            </div>
                          ) : null}
                          {user.error !== "" ? (
                            <div className="invalid-feedback d-block">
                              {user.error}
                            </div>
                          ) : null}
                          <button
                            type="submit"
                            className="btn btn-primary login-btn form-button"
                          >
                            Login
                          </button>
                          <div className="mt-2" style={{textAlign:"left"}} >
                            
                          <div className="form-group">
                        <div className=" custom-checkbox custom-control-inline" >
                              <input
                                type="checkbox"
                                id="titleAndDescription"
                                name="titleAndDescription"
                                onChange={handleCheckboxClick}
                                // style={{marginTop:"5px"}}
                                checked={rememberMe}
                              />
                              <label htmlFor="titleAndDescription" style={{marginLeft:"8px", marginTop:4}}>Remember me</label>
                              </div>
                      </div>
                          </div>
                          <div className="forgot-link" style={{marginTop:-25}}>
                            <Link to={"/forgotPassword"}>Forgot Password</Link>
                          </div>
                        </Form>
                      </>
                    )}
                  </Formik>
                  <form className="form-block"></form>

                  <div className="line">
                    <div>
                      <span>or</span>
                    </div>
                  </div>

                  <div className="social-btn-block">
                    <LoginSocialFacebook
                      appId="1330044557617882"
                      
                      fieldsProfile={
                        "id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender"
                      }
                      onLoginStart={onLoginStart}
                      // onLogoutSuccess={onLogoutSuccess}
                      redirect_uri={REDIRECT_URI}
                      onResolve={({ provider, data }: IResolveParams) => {
                        dispatch<any>(
                          setSocialDetails({
                            provider: provider,
                            profile: data,
                            type: "login",
                          })
                        ).then(()=> data && dispatch<any>(
                          getUserLoginSocial({
                            accesstoken: data.accessToken,
                            socialType: 2,
                            roleId: 2,
                            roleType: "Customer",
                          })
                        ));
                      }}
                      onReject={(err) => {
                        console.log(err);
                      }}
                    >
                      <button className="btn btn-outline-primary f">
                        <i className="f-icon"></i>
                        <span>Continue with Facebook</span>
                      </button>
                    </LoginSocialFacebook>
                    <GoogleLogin
                      clientId= {constant.GOOGLE_CLIENT_ID}
                      buttonText="Sign in with Google"
                      render={(renderProps) => (
                        <button
                          onClick={renderProps.onClick}
                          className="btn btn-outline-primary g"
                        >
                          <i className="g-icon"></i>
                          <span>Continue with Google</span>
                        </button>
                      )}
                      onSuccess={onSuccess}
                      onFailure={onFailure}
                      cookiePolicy={"single_host_origin"}
                      isSignedIn={false}
                    />

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="footer-bottom">
            <p className="text-center">
              Copyright &copy;2023 eFindit. All rights reserved
            </p>
          </div>
        </footer>
        { visible &&   <div className="modal-backdrop show"></div>}
      </>
    </DefaultLayout>
  );
};
